module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Arenas/images/flag.b892cdae.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Arenas/images/flag.png
// module id = 2501
// module chunks = 11